import {AbstractEvent} from "@/modules/base/events";
import {Team} from "@/modules/team/entity";
import {CoinsProductInterface} from "@/modules/action-points/interfaces";

export default class BeforeBuyCoinsEvent extends AbstractEvent {
  constructor(
    public team: Team,
    public product: CoinsProductInterface,
  ) {
    super();
  }
}